<template lang="html">
    <ul class="main-menu__submenu">
        <li class="main-menu__item has-droprdown">
            <a v-bind:class="{'active': (activeLinks.indexOf(settingLink)+1)}" @click.prevent.stop="$root.toggleMenu($event)">
                <md-icon class="arrow-icon-right">keyboard_arrow_right</md-icon>
                <md-icon class="arrow-icon-down">keyboard_arrow_down</md-icon>
                <md-icon>settings</md-icon>
                <span>Настройки</span>
            </a>
            <ul class="main-menu__submenu">
                <component v-if="Object.keys(settings).length" v-bind:is="menu" v-for="menu in settings" v-bind:key="menu.name"></component>
            </ul>
        </li>
    </ul>
</template>
<script>
    export default {
        name: 'module-main-menu',
        sort: 7,
        //название модуля тут settings потому что есть ситуации когда надо дасть доступ к модулу, а не к настройкам
        //на BackEnd есть действие settings_access, с которым и будет работать этот параметр
        module: 'settings',
        computed: {
            modules() {
                return this.$store.state.module.modules;
            },
            settingsLinkActiveClass() {
                return this.$router.options.settingsLinkActiveClass;
            },
            settingLink() {
                if (!this.$route.meta || !this.$route.meta.setting_link) return '';
                return this.$route.meta.setting_link
            }            
        },
        data() {
            return {
                module: 'settings',
                sort: 7,
                settings: {},
                activeLinks: ['Prices', 'DealsStatuses', 'TrackingStatuses', 'Users', 'Logs', 'ModulesOverview', 'Printers', 'Companies', 'Autos', 'Auto'],
            }
        },
        methods: {
            getModules() {
                this.$store.dispatch('module/getModules');
            }
        },
        created() {
            this.getModules();
            let menu = this.$root.menus;
            if (menu['Settings']) this.settings = menu['Settings'];
        }
    }
</script>



// WEBPACK FOOTER //
// MainMenu.vue?e9e05cb2